import { idbGet, idbSet } from '@/shared/IndexedDBHelper';

export class RecycleBinManager {
    static shared = new RecycleBinManager();
    private get key(): string {
        return "kRecycleBinItems";
    }

    addedById: { [key: string]: { exist: () => boolean } };
    private mutationGeneration = 0;

    private constructor() {
        this.addedById = {};
    }

    async setup(): Promise<void> {
        return this.restoreFromStorage();
    }

    set(keys: string[])  {
        this.applyKeys(Array.isArray(keys) ? keys : []);
    }

    addItem(draftId: string) {
        this.addedById[draftId] = {
            exist: () => true
        };
        this.persist();
    }

    removeItem(draftId: string) {
        delete this.addedById[draftId];
        this.persist();
    }

    itemExists(draftId: string): boolean {
        return this.addedById[draftId]?.exist() || false;
    }

    cleanup(localOnly: boolean) {
    }

    didDeleteProjects(projectIds: string[]) {

    }

    uploadingProject(projectId: string) {

    }

    didLoggedOutFromCloud() {

    }

    private applyKeys(keys: string[], shouldPersist = true) {
        this.addedById = {};
        keys.forEach(key => {
            this.addedById[key] = {
                exist: () => true
            };
        });

        if (shouldPersist) {
            this.persist();
        }
    }

    private persist() {
        const keys = Object.keys(this.addedById);
        idbSet<string[]>(this.key, keys).catch(error => {
            console.error('RecycleBinManager: failed to persist recycle bin', error);
        });
    }

    private restoreFromStorage(): Promise<void> {
        return idbGet<string[]>(this.key)
            .then(keys => {
                if (!Array.isArray(keys)) {
                    return;
                }
                this.applyKeys(keys, false);
            })
            .catch(error => {
                console.error('RecycleBinManager: failed to restore recycle bin', error);
            });
    }
}
